// extracted by mini-css-extract-plugin
export default {"toolsPanel":"ScanBoxView_toolsPanel__PNTJP"};